import { __assign, __extends } from "tslib";
// DS: C17
/** Top navigation bar for desktop */
import React from 'react';
import shortenNumber from '../../utils/shortenNumber';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Url, URLS } from '@wix/da-url';
import Logo from '../../Logo';
import { withThemeContext } from '../../Context';
import CartIcon from '../../Icons/Cart';
import MessageIcon from '../../Icons/Message';
import ChatIcon from '../../Icons/Comment';
import { IconSize } from '../../Icons/IconWrap';
import SubmitMenu from './SubmitMenu';
import UserDropdownMenu from './UserDropdownMenu';
import NotificationsDropdown from './NotificationsDropdown';
import Sticky from '../../Sticky';
import SearchPopup from '../_partials/SearchPopup/SearchPopup';
import ErrorBoundary from '../../ErrorBoundary';
import BiLink from '../../biLogger/Components/BiLink';
import BiButton from '../../biLogger/Components/BiButton';
import { BiEventType, BiDataHook, ReferralType, } from '../../biLogger/constants';
import VersionToggle from '../_partials/VersionToggle';
import { withVerification, } from '../../VerificationPopup/withVerification';
import withFeatureFlags from '../../redux/flags/withFeatureFlags';
import Flag from '../../redux/flags/Flag';
import DealerAd from '../../DealerAd';
import ChatButtonAndDropdown from './ChatButtonAndDropdown';
import PortfolioTooltip from '../_partials/PortfolioTooltip';
import SearchBar from './SearchBar';
import ResponsiveMenuItems from './ResponsiveMenuItems';
import s from './SiteHeader.scss';
var OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT = 100;
var enhance = compose(withFeatureFlags, withVerification, withThemeContext, withTranslation());
var SiteHeaderDesktop = /** @class */ (function (_super) {
    __extends(SiteHeaderDesktop, _super);
    function SiteHeaderDesktop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userDropdownRef = React.createRef();
        _this.handleSearchButtonClick = function () {
            var _a = _this.props, isSearchPopupShown = _a.isSearchPopupShown, openSearchPopup = _a.openSearchPopup;
            var isSearchPage = window.location.pathname.startsWith('/search');
            if (!isSearchPage) {
                if (!isSearchPopupShown) {
                    openSearchPopup();
                }
            }
            else {
                _this.props.onSiteHeaderSearchButtonClicked &&
                    _this.props.onSiteHeaderSearchButtonClicked();
            }
        };
        _this.limitNumber = function (number) {
            return number > 999 ? shortenNumber(number, 0, Math.floor) : "" + number;
        };
        _this.handleNotificationsDropdownTouch = function (e) {
            if (!_this.props.isNotificationsDropdownOpen) {
                // default actions should only be prevented for the initial click
                // once the notification menu is shown, we want to let other touch
                // events pass through
                e.preventDefault();
            }
            _this.handleNotificationsDropdownHover();
        };
        _this.handleNotificationsDropdownHover = function () {
            _this.openNotificationsDropdownTimerId = window.setTimeout(_this.props.openNotificationsDropdown, OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT);
            window.clearTimeout(_this.closeNotificationsDropdownTimerId);
        };
        _this.handleNotificationsDropdownLeave = function () {
            window.clearTimeout(_this.openNotificationsDropdownTimerId);
            _this.props.closeNotificationsDropdown();
        };
        return _this;
    }
    SiteHeaderDesktop.prototype.renderNotesIcon = function () {
        var noteCount = this.props.noteCount;
        return (React.createElement("span", null,
            React.createElement(MessageIcon, { size: IconSize.MEDIUM, className: s['envelope-icon'] }),
            noteCount > 0 && (React.createElement("span", { className: s['number'] }, this.limitNumber(noteCount)))));
    };
    SiteHeaderDesktop.prototype.renderIconButtonsBlock = function () {
        var _a = this.props, isLoggedIn = _a.isLoggedIn, cartCount = _a.cartCount, feedbackCount = _a.feedbackCount, disableVersionSwitcher = _a.disableVersionSwitcher, switchVersion = _a.switchVersion, isNotificationsDropdownOpen = _a.isNotificationsDropdownOpen, t = _a.t, flags = _a.flags;
        return (React.createElement("div", { className: s['icon-buttons-block'] },
            React.createElement(Flag, { condition: "header_ad" },
                React.createElement(DealerAd, { realEstateId: "9c14ea7a-8c35-429a-9857-00ad04ebb4c1", className: s['ad-slot'] })),
            !disableVersionSwitcher && (React.createElement("div", { className: s['version-switcher'] },
                React.createElement(VersionToggle, { onToggle: switchVersion }),
                React.createElement("div", { className: s['separator'] }))),
            cartCount > 0 && (React.createElement(BiLink, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_url: URLS.CART,
                    link_name: 'cart',
                    indicator: cartCount,
                }, className: s['out-of-menu-link'], href: URLS.CART, "aria-label": t('siteHeader.a11y.cart.withItems', {
                    formattedCount: this.limitNumber(cartCount),
                }) },
                React.createElement("span", null,
                    React.createElement(CartIcon, { size: IconSize.MEDIUM, className: s['cart-icon'] }),
                    React.createElement("span", { className: classnames(s['number'], s['number-label__green']) }, this.limitNumber(cartCount))))),
            isLoggedIn &&
                (flags.includes('chat')
                    ? this.renderChatLink()
                    : this.renderNotesLink()),
            isLoggedIn && (React.createElement(NotificationsDropdown, { feedbackCount: this.limitNumber(feedbackCount), isOpen: isNotificationsDropdownOpen, onMouseEnter: this.handleNotificationsDropdownHover, onMouseLeave: this.handleNotificationsDropdownLeave, onTouchEnd: this.handleNotificationsDropdownTouch, href: Url.feedbackLink(), "aria-label": t(feedbackCount
                    ? 'siteHeader.a11y.notifications.withItems'
                    : 'siteHeader.a11y.notifications.withoutItems', {
                    formattedCount: this.limitNumber(feedbackCount),
                }), biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_name: 'notifications',
                    indicator: feedbackCount,
                } })),
            !isLoggedIn && (React.createElement(BiLink, { biData: {
                    evid: BiEventType.REDIRECT_TO_LOGIN,
                    referral_info: ReferralType.HEADER,
                }, className: s['out-of-menu-button'], href: Url.joinLink(flags.includes('join_to_watch') ? 'topnav' : undefined) }, t('siteHeader.join'))),
            !isLoggedIn && (React.createElement(BiLink, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_url: Url.loginLink(),
                    link_name: 'login',
                }, className: s['out-of-menu-button'], href: Url.loginLink() }, t('siteHeader.signIn')))));
    };
    /**
     * Because chat is taking over notes, we need to render the chat icon instead
     * of the notes one for the verification popup if the feature is enabled
     * */
    SiteHeaderDesktop.prototype.renderChatLink = function () {
        var _a = this.props, isVerificationNeeded = _a.isVerificationNeeded, chatCount = _a.chatCount, isLegacyHeader = _a.isLegacyHeader, disableFloatingChat = _a.disableFloatingChat, pushVerificationPopup = _a.pushVerificationPopup, t = _a.t;
        if (isVerificationNeeded) {
            return (
            // TODO: current Chat icon will send BI data as if it's a Notes icon
            // BI might want to change this data to be Chat-related
            React.createElement(BiButton, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_url: URLS.CHAT_HOME,
                    link_name: 'chat',
                    indicator: chatCount,
                }, className: classnames(s['needs-verification-button'], s['out-of-menu-link'], s['icon-button-has-submenu']), onClick: function () { return pushVerificationPopup('chat'); }, "aria-label": t('siteHeader.a11y.openAccountVerificationDialog') },
                React.createElement(ChatIcon, { size: IconSize.MEDIUM, className: s['chat-icon'] })));
        }
        return (React.createElement(ChatButtonAndDropdown, { disableDropdown: isLegacyHeader, disableFloatingChat: disableFloatingChat, indicator: chatCount > 0 && (React.createElement("span", { className: s['number'] }, this.limitNumber(chatCount))) }));
    };
    SiteHeaderDesktop.prototype.renderNotesLink = function () {
        var _a = this.props, noteCount = _a.noteCount, t = _a.t, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup;
        if (isVerificationNeeded) {
            return (React.createElement(BiButton, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_url: URLS.NOTES,
                    link_name: 'notes',
                    indicator: noteCount,
                }, className: classnames(s['needs-verification-button'], s['out-of-menu-link'], s['icon-button-has-submenu']), onClick: function () { return pushVerificationPopup('notes'); }, "aria-label": t('siteHeader.a11y.openAccountVerificationDialog') }, this.renderNotesIcon()));
        }
        return (React.createElement(BiLink, { biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_url: URLS.NOTES,
                link_name: 'notes',
                indicator: noteCount,
            }, className: classnames(s['out-of-menu-link'], s['icon-button-has-submenu']), "aria-label": t(noteCount > 0
                ? 'siteHeader.a11y.notes.withItems'
                : 'siteHeader.a11y.notes.withoutItems', {
                formattedCount: this.limitNumber(noteCount),
            }), href: URLS.NOTES }, this.renderNotesIcon()));
    };
    SiteHeaderDesktop.prototype.render = function () {
        var _a = this.props, environment = _a.environment, disableThemeSwitcher = _a.disableThemeSwitcher, isLegacyHeader = _a.isLegacyHeader, theme = _a.theme, isSearchPopupShown = _a.isSearchPopupShown, isUserDropdownOpen = _a.isUserDropdownOpen, isPortfolioTooltipShown = _a.isPortfolioTooltipShown, closeSearchPopup = _a.closeSearchPopup, hidePortfolioTooltip = _a.hidePortfolioTooltip, activeMainMenuItem = _a.activeMainMenuItem, watchCount = _a.watchCount, isLoggedIn = _a.isLoggedIn, t = _a.t;
        var shouldShowEnv = environment && ['rc', 'dev'].includes(environment);
        var isDarkTheme = theme === 'dark';
        return (React.createElement(ErrorBoundary, { className: s['root'] },
            React.createElement("header", { role: "banner", className: s['root'], "data-hook": BiDataHook.TOP_NAV },
                shouldShowEnv && (React.createElement("div", { className: s['env'] }, String(environment).toUpperCase())),
                React.createElement(BiLink, { biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_url: URLS.ROOT,
                        link_name: 'logo',
                    }, href: URLS.ROOT, "aria-label": t('siteHeader.a11y.home') },
                    React.createElement(Logo, { className: s['logo'], textColor: isDarkTheme ? 'white' : 'black', size: "tiny" })),
                React.createElement("div", { className: s['with-separators'] },
                    React.createElement(ResponsiveMenuItems, { activeMainMenuItem: activeMainMenuItem, watchCount: watchCount, isLoggedIn: isLoggedIn }),
                    React.createElement(SearchBar, { onClick: this.handleSearchButtonClick }),
                    this.renderIconButtonsBlock(),
                    React.createElement(UserDropdownMenu, { isOpen: isUserDropdownOpen, className: s['icon-submenu'], disableThemeSwitcher: disableThemeSwitcher, isLegacyHeader: isLegacyHeader, innerRef: this.userDropdownRef }),
                    isPortfolioTooltipShown && this.userDropdownRef.current && (React.createElement(PortfolioTooltip, { className: s['portfolio-tooltip'], referenceElement: this.userDropdownRef.current, onDismiss: hidePortfolioTooltip }))),
                React.createElement(SubmitMenu, { isOpen: true, className: s['icon-button-has-submenu'], menuClassName: s['icon-submenu'], isLegacyHeader: isLegacyHeader })),
            isSearchPopupShown && (React.createElement(SearchPopup, { onClose: closeSearchPopup, isLegacyHeader: isLegacyHeader, isMobile: false }))));
    };
    return SiteHeaderDesktop;
}(React.PureComponent));
var StickySiteHeaderDesktop = function (props) {
    var zIndex = +s['zIndex'];
    return (React.createElement(Sticky, __assign({}, (!Number.isNaN(zIndex) && { zIndex: zIndex })), function (isStuck) {
        return React.createElement(SiteHeaderDesktop, __assign({}, props));
    }));
};
StickySiteHeaderDesktop.displayName = 'StickySiteHeaderDesktop';
export default enhance(StickySiteHeaderDesktop);
//# sourceMappingURL=SiteHeaderDesktop.js.map